import { styled } from '@stitches/react';
import { ReactNode, useMemo } from 'react';
import { useElements, useScene } from '../../hooks';

export const BoxElement = ({
  elementID,
  children,
}: {
  elementID: string;
  children: ReactNode;
}) => {
  const scene = useScene();
  const [element] = useElements({ id: elementID });

  const Div = useMemo(
    () => styled('div', element?.props?.class as {}),
    [element?.props?.class]
  );

  return (
    <Div element-type="box" id={element?.id} {...scene.launcherStateProps}>
      {children}
    </Div>
  );
};
